import { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  AuraLayout,
  Button,
  Layout,
  PageTitle,
  RoundedCheckIcon,
} from 'lola-framework-ui-test';
import { FlowHeroMark } from '../components/FlowHeroMark';
import { APP_ROUTES } from '../constants';
import { useStore } from '../store/globalState';
import { ScrollFadeIndicator } from '../components/ScrollFadeIndicator';

/**
 * Gallery-safe cash-deposit confirmation screen.
 *
 * Check-circle hero matches fund-request "transfer processed".
 * Shows a success-style message and a single footer CTA.
 */
export const DepositOnTheWayPage = memo(() => {
  const { t } = useTranslation();
  const { theme } = useStore();
  const navigate = useNavigate();
  const colorConfig = theme.whiteView;
  const { backgroundBtn, textColorBtn, bodyCopy, dropzoneColors, backgroundIcon } =
    colorConfig;

  return (
    <AuraLayout colorConfig={colorConfig} className="flow-landing-page">
      <Layout.Content className="landing-section flow-hero-section">
        <ScrollFadeIndicator color={colorConfig.bodyCopy} />
        <section className="flow-hero">
          <FlowHeroMark
            dropzoneColors={dropzoneColors}
            backgroundIcon={backgroundIcon}
          >
            <RoundedCheckIcon size={60} colors={dropzoneColors} />
          </FlowHeroMark>
          <section className="landing-container">
            <PageTitle
              highlight={t('cashDeposit.onTheWayHighlight')}
              highlightColor={bodyCopy}
              secudnary={t('cashDeposit.onTheWaySecondary')}
              secudnaryColor={bodyCopy}
            />
          </section>
        </section>
      </Layout.Content>
      <Layout.Footer>
        <section className="footer-section">
          <Button
            size="large"
            background={backgroundBtn}
            color={textColorBtn}
            onClick={() => navigate(APP_ROUTES.CASH_DEPOSIT_LANDING_PAGE)}
          >
            {t('cashDeposit.done')}
          </Button>
        </section>
      </Layout.Footer>
    </AuraLayout>
  );
});
